export default __webpack_public_path__ + "static/media/BOD Regular Meeting September 04, 2020.003d2030.pdf";